import { IS_APP } from "@/__main__/constants.mjs";
import { refs__PRIVATE as refs } from "@/feature-analytics/tracker.mjs";
import {
  finalizeProviders,
  initializeProviders,
} from "@/feature-analytics/utils.mjs";
import getOsType from "@/util/get-os-type.mjs";

const SCORECARD_RESEARCH = "https://sb.scorecardresearch.com/beacon.js";

const GOOGLE_TAG = (() => {
  const WEB_GOOGLE_TAG = "G-TYFXT6MBEG";
  // we only care about the OS when IS_APP
  if (!IS_APP) return WEB_GOOGLE_TAG;
  const PLATFORM_GOOGLE_TAGS = {
    win32: "G-7PLQ09BZ1G",
    darwin: "G-W05DZREYWT",
    linux: "G-X3L3YNMP2Q",
  };
  // report as "windows" if not in the list
  return PLATFORM_GOOGLE_TAGS[getOsType()] || PLATFORM_GOOGLE_TAGS["win32"];
})();

const GOOGLE_TAG_URL = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_TAG}`;

export const GA4_WEB_DOWNLOAD_EVENT = "Web_Download";
export const GA4_APP_PLAY_GAME_EVENT = "App_Play_Game";

const original = {
  gtag: null,
};

// XXX: notice that we do not have finalize function for current providers
// need to figure out a clean way to do such cleanup instead of sth like
// `delete globalThis.ga;`
const env = {
  setupPromise: null,
  providers: [
    {
      name: "google_tag",
      url: GOOGLE_TAG_URL,
      web: true,
      app: true,
      initialize: () => {
        /* eslint-disable no-restricted-properties */
        globalThis.dataLayer ||= [];
        const gtag = (globalThis.gtag ||= function () {
          globalThis.dataLayer.push(arguments);
        });
        /* eslint-enable no-restricted-properties */

        gtag("js", new Date());

        gtag("config", GOOGLE_TAG);

        original.gtag = refs.gtag;

        refs.gtag = gtag;
      },
      finalize: () => {
        refs.gtag = original.gtag;
      },
    },
    {
      name: "scorecard_research",
      url: SCORECARD_RESEARCH,
      web: true,
      app: false,
      initialize: () => {
        /* eslint-disable no-restricted-properties */
        const comscore = globalThis._comscore || [];
        globalThis._comscore = comscore;
        /* eslint-enable no-restricted-properties */
        // Comscore for website
        comscore.push({ c1: "2", c2: "28660385" });
      },
    },
  ],
};

export function setup() {
  if (!env.setupPromise) {
    env.setupPromise = initializeProviders(env.providers);
  }

  return env.setupPromise;
}

export function teardown() {
  // XXX: do we need to check setupPromise ready?
  finalizeProviders(env.providers);
  env.setupPromise = null;
}
